import type { CSSProperties } from 'react';

import classNames from 'classnames';

import { getWidthStyle } from '../utils/sizing';

import * as styles from './Accordion.css';
import type { AccordionContentElementProps } from './Accordion.types';

const DEFAULTS = {
  padding: '16px 0px 16px 0px',
};

export function AccordionContentElement(props: AccordionContentElementProps) {
  const { element, children, attributes, className } = props;
  const { width, width_max, padding, mobilePadding, customAttributes } = element.attrs || {};

  return (
    <div
      {...customAttributes}
      className={classNames(className, styles.accordionContent, customAttributes?.className)}
      style={
        {
          '--width': getWidthStyle(width, width_max).width,
          '--max-width': getWidthStyle(width, width_max).maxWidth,
          '--padding': padding ?? DEFAULTS.padding,
          '--mobile-padding': mobilePadding ?? padding ?? DEFAULTS.padding,
        } as CSSProperties
      }
      {...attributes}
      onClick={(e) => {
        e.stopPropagation();
      }}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.stopPropagation();
        }
      }}
    >
      <div className={styles.accordionContentInner}>{children}</div>
    </div>
  );
}
